import * as React from 'react';
import type {ComponentProps} from '@enonic/react-components';
import {Regions} from '@enonic/react-components';
import {MainNavigation} from './MainNavigation';
import {Footer} from './Footer';
import {Breadcrumb} from './Breadcrumb';
import type {BreadcrumbData, FooterData, MainNavigationData} from '/types/CommonData';

export function DefaultPage({component, common, meta}: ComponentProps) {
    return (
        <>
            <MainNavigation data={common?.mainNavigation as MainNavigationData | undefined}/>
            <div id="main-content" className="grow">
                <Breadcrumb data={common?.breadcrumb as BreadcrumbData | undefined}/>
                <Regions component={component} meta={meta} common={common}/>
            </div>
            <Footer data={common?.footer as FooterData | undefined}/>
        </>
    );
}
